<template>
  <container :isModal="false" :loading="false">
    <template v-slot:body>
      <div class="challenge-wrapper">
        <div class="challenge-card">
          <div class="challenge-logo">
            <img class="img-fluid main-logo" alt="GovPass AET" />
          </div>

          <div class="challenge-welcome">
            <h1 class="challenge-title">Verificação de segurança</h1>
            <p class="challenge-subtitle">
              Complete a verificação abaixo para acessar o sistema
            </p>
          </div>

          <div class="challenge-turnstile">
            <div ref="turnstileRef"></div>
          </div>
        </div>
      </div>
    </template>
  </container>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useApiWithAuth } from "../../modules/api";
import { TURNSTILE_VERIFIED } from "../../modules/auth";
import { useToast } from "../../modules/message";

export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const turnstileRef = ref<HTMLElement>();
    const verificando = ref(false);
    let widgetId: string | undefined;

    const verificar = (token: string) => {
      if (verificando.value) return;
      verificando.value = true;
      const { post } = useApiWithAuth();
      post("/verificacao", { turnstileToken: token })
        .then(() => {
          sessionStorage.setItem(TURNSTILE_VERIFIED, "true");
          const redirect = route.query.redirect as string;
          router.push(redirect || { name: "home" });
        })
        .catch((e) => {
          verificando.value = false;
          if (!e?.response) {
            useToast().error(
              "Não foi possível conectar ao servidor. Verifique sua internet " +
                "ou se a rede/firewall da sua empresa permite acesso a " +
                "aet-api.govpass.com.br, e tente novamente.",
              { life: 20000 }
            );
          } else {
            useToast().error(
              e.response.data?.message ||
                "Não foi possível concluir a verificação. Tente novamente."
            );
          }
        });
    };

    const renderTurnstile = () => {
      if (window.turnstile && turnstileRef.value) {
        widgetId = window.turnstile.render(turnstileRef.value, {
          sitekey: "0x4AAAAAAC21H5ax1d8XlZhC",
          callback: (token: string) => {
            verificar(token);
          }
        });
      }
    };

    onMounted(() => {
      const interval = setInterval(() => {
        if (window.turnstile?.render) {
          clearInterval(interval);
          renderTurnstile();
        }
      }, 200);
      setTimeout(() => clearInterval(interval), 10000);
    });

    onBeforeUnmount(() => {
      if (widgetId && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    });

    return {
      turnstileRef
    };
  },
  components: {}
});
</script>

<style scoped lang="scss">
.challenge-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: $space-4;
}

.challenge-card {
  background: $bg-surface;
  border-radius: $radius-xl;
  box-shadow: $shadow-xl;
  padding: $space-10 $space-8;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.challenge-logo {
  display: flex;
  justify-content: center;
  margin-bottom: $space-6;

  img {
    max-height: 48px;
    width: auto;
  }
}

.challenge-welcome {
  margin-bottom: $space-8;
}

.challenge-title {
  font-size: $font-size-2xl;
  font-weight: $font-weight-bold;
  color: $text-primary;
  margin: 0 0 $space-2 0;
}

.challenge-subtitle {
  font-size: $font-size-base;
  color: $text-secondary;
  margin: 0;
}

.challenge-turnstile {
  display: flex;
  justify-content: center;
  margin-top: $space-6;
}
</style>
